import { v1ApiClient } from '@/services';
import type {
  Operation,
  OperationRequestBody,
  Schema,
} from '@/shared/api/generated';

type CreateAggregatedReportFolderOperation =
  Operation<'CreateAggregatedReportFolder'>;

export type CreateAggregatedReportFolderParams =
  CreateAggregatedReportFolderOperation['parameters']['path'] &
    OperationRequestBody<'CreateAggregatedReportFolder'>;

export type CreateAggregatedReportFolderResponse =
  Schema<'AggregatedReportFolder'>;

export const createAggregatedReportFolder = ({
  workspace_id,
  ...body
}: CreateAggregatedReportFolderParams): Promise<CreateAggregatedReportFolderResponse> =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/aggregated-report-folders`, body)
    .then((res) => res.data);
